import * as actions from '../../actions/blog';

export const initialState = {
    blog: {
        records: 0,
        posts: undefined,
    },
    post: undefined,
    loading: false,
    saving: false,
    error: false,
};

export const blogState = (state = initialState, action) => {
    switch (action.type) {
        case actions.POSTS_LOADED:
            return { ...state, blog: action.payload, error: false, saving: false };
        case actions.POST_LOADED:
            return { ...state, post: action.payload, error: false, saving: false };
        case actions.SAVING:
            return { ...state, saving: action.payload };
        case actions.BLOG_LOADING:
            return { ...state, loading: action.payload };
        case actions.ERROR:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};
